(ns dashboard.views.settings.billing
  (:require
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   ["@heroicons/react/outline" :refer [CurrencyDollarIcon]]))

(defn content []
  [:div.divide-y.divide-gray-200
   [:div.py-6.px-4.sm:p-6.lg:pb-8
    [:div.text-center
     [:> CurrencyDollarIcon
      {:class "mx-auto h-12 w-12 text-gray-400"
       :aria-hidden true}]
     [:h2.mt-2.text-lg.font-medium.text-gray-900
      "No Invoices"]
     [:p.mt-1.text-sm.text-gray-500
      "You haven’t received any invoices for the moment."]]]
   [:div.divide-y.divide-gray-200
    [:div.py-4.px-4.flex.justify-end.sm:px-6
     [:button.ml-5.bg-primary-700.border.border-transparent.rounded-md.shadow-sm.py-2.px-4.inline-flex.justify-center.text-sm.font-medium.text-white.hover:bg-primary-800.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500
      {:type "submit"}
      (tr :action/save)]]]])
